import type { DataTableColumn, DataTableSortData } from '../../ui/DataTable/types';

export type AppliedSortTag = {
  field: string;
  direction: 'asc' | 'desc';
  label: string;
};

function columnTitleForSortField<T>(
  columns: Array<DataTableColumn<T>>,
  field: string
): string {
  const column = columns.find((candidate) => candidate.sortField === field);
  if (column && typeof column.name === 'string' && column.name.trim() !== '') {
    return column.name;
  }
  return field.replaceAll('_', ' ');
}

/**
 * Build removable sort chips for the filter drawer.
 * DataTable currently supports a single active sort; returned as a list for UI.
 */
export function buildAppliedSortTags<T>(args: {
  sort: DataTableSortData | null | undefined;
  defaultSort?: DataTableSortData | null;
  columns: Array<DataTableColumn<T>>;
  /** When true, only show a tag if sort differs from defaultSort. */
  onlyUserCustomSort?: boolean;
}): AppliedSortTag[] {
  const { sort, defaultSort, columns, onlyUserCustomSort = true } = args;
  if (sort == null) return [];

  if (onlyUserCustomSort && defaultSort) {
    if (
      sort.field === defaultSort.field &&
      sort.direction === defaultSort.direction
    ) {
      return [];
    }
  }

  const title = columnTitleForSortField(columns, sort.field);
  const directionLabel = sort.direction === 'asc' ? 'Ascending' : 'Descending';

  return [
    {
      field: sort.field,
      direction: sort.direction,
      label: `${title} · ${directionLabel}`
    }
  ];
}
